import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-dark text-center py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <p className="mb-0">© 2023 Vtech Ventures. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
